import React from 'react'
import * as Icon from 'react-feather';
import { Menu, Transition } from '@headlessui/react'
import { Link } from 'react-router-dom'
import cookie from "../libs/cookie/client";
import { useHistory } from "react-router-dom";
// import BASEURL from "../libs/service/api";
function AccountDropdown(props) {
  const { toast } = require('tailwind-toast')
  const history = useHistory();


  const Ifregister = () => {
    if (cookie.getItem('needsassesmentid') === 0) {
      history.push('/area-of-interest/');
      toast().success('Please Complete your Journey First', '').with({
        shape: 'square',
        duration: 7000,
        speed: 200,
        positionX: 'center',
        positionY: 'top',
        color: 'text-white bg-primary border-primary-dark border rounded-lg',
        fontColor: 'white',
        fontTone: 0
    }).show()
    } else {
      history.push('/dashboard/' +  cookie.getItem('needsassesmentid'))
    }
  }

  const logOut = () => {
    cookie.removeItem('needsassesmentid');
    cookie.removeItem('areaofinterest');
    cookie.removeItem('passwordexist');
    cookie.removeItem('email');
    cookie.removeItem('userid');
    cookie.removeItem('authorizationKey');
    cookie.removeItem('username');
    cookie.removeItem('queryFormSubmmited');
    cookie.removeItem('datatablength')
    localStorage.removeItem("needsassesmentid");
    localStorage.removeItem("areaofinterest");
    localStorage.removeItem("passwordexist");
    localStorage.removeItem("email");
    localStorage.removeItem("userid");
    localStorage.removeItem("authorizationKey");
    localStorage.removeItem("username");
    localStorage.removeItem("queryFormSubmmited");
    // window.location.href = BASEURL + "login";
    history.push('/')
    window.localStorage.clear();
    window.location.reload();
  }

  return (

    <Menu>
      <Menu.Button className="flex  items-center font-bold underline mb-2 focus:outline-none px-4 py-2 rounded-full bg-opacity-60 bg-primary-extraLight">{cookie.getItem("email")}<Icon.ChevronDown className="ml-2" /></Menu.Button>
      <Transition
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute bg-white rounded-lg border-2 border-primary right-0 p-2 min-w-77">
          <div className="flex items-center text-primary uppercase text-xs font-semibold p-2">
            <div>{cookie.getItem("username")}</div><div className="mx-2 w-1 h-1 rounded-full bg-primary"></div><div>Viewpro</div>
          </div>
          <Menu.Item>
            {({ active }) => (

              <Link
                className="flex p-2 rounded-md font-semibold hover:bg-vp hover:text-primary"
                onClick={Ifregister}
              >
                Dashboard
              </Link>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (

              <Link
                className="flex p-2 rounded-md font-semibold hover:bg-vp hover:text-primary"
                to="/my-account/"
              >
                Profile
              </Link>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (

              <Link
                className="flex p-2 rounded-md font-semibold hover:bg-vp hover:text-primary"
                onClick={logOut}
              >
                Log out
              </Link>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
    

  )
  
}

export default AccountDropdown

